<div>
  <div style="padding-left: 25px;">
    <button (click)="changeChartType(ChartType.ATM_IV)" [class.active]="type=='atmIv'" class="iv-inline-button">ATM IV</button>
    <button (click)="changeChartType(ChartType.DELTA_SKEW)" [class.active]="type=='deltaSkew'" class="iv-inline-button">Delta
      Skew
    </button>
    <button (click)="changeChartType(ChartType.DELTA_BUTTERFLY)" [class.active]="type=='deltaButterfly'"
            class="iv-inline-button">Delta Butterfly
    </button>
  </div>

  <div *ngIf="type===ChartType.ATM_IV">
    <iv-live-atm-iv class="ignore-darkreader" [instrument]="instrument"></iv-live-atm-iv>
  </div>

  <div *ngIf="type===ChartType.DELTA_SKEW">
    <iv-live-delta-chart class="ignore-darkreader" [instrument]="instrument" [type]="'SKEW'"></iv-live-delta-chart>
  </div>

  <div *ngIf="type===ChartType.DELTA_BUTTERFLY">
    <iv-live-delta-chart class="ignore-darkreader" [instrument]="instrument" [type]="'BUTTERFLY'"></iv-live-delta-chart>
  </div>
  <div *ngIf="type===ChartType.ATM_IV" class="definition" >
    At the money volatility for a set of standard terms - 30, 60, 90, 120, 150, 180, 270, 360, 720 and 1080 days.
  </div>
  <div *ngIf="type===ChartType.DELTA_SKEW" class="definition" >
    Skew (Risk Reversal) for a set of standard terms. Calculated as a difference between Put and Call IV for given delta values of 25% and 10%
  </div>
  <div *ngIf="type===ChartType.DELTA_BUTTERFLY" class="definition" >
    Butterfly for a set of standard terms. Calculated as an excess of Put and Call IV for given delta over doubled ATM IV for delta values of 25% and 10%
  </div>
</div>
